module.exports = __webpack_public_path__ + "img/bcn.6de5d6ec.svg";